import httpClient from "./httpClient";
import { fetchAllPaged } from "./fetchAllPaged";

/** @returns {Promise<Array>} */
export const getAllStores = async () =>
  fetchAllPaged(httpClient, "/store/all", "stores");

/** One page: `limit` default 100 (server), max 500. */
export const getStoresPage = async (params = {}) => {
  const { data } = await httpClient.get("/store/all", { params });
  return {
    stores: data.stores || [],
    total: data.total ?? 0,
    limit: data.limit,
    skip: data.skip,
  };
};

/** @returns {Promise<object|null>} */
export const getStoreBySlug = async (slug) => {
  const { data } = await httpClient.get(
    `/store/slug/${encodeURIComponent(slug)}`
  );
  return data.store || null;
};

/** @returns {Promise<Array>} */
export const getCouponsForStoreSlug = async (slug) => {
  const { data } = await httpClient.get(
    `/store/slug/${encodeURIComponent(slug)}/coupons`
  );
  return data.coupons || [];
};
